<app-navbar [textColor]="navbarTextColor" />
<main>
  <router-outlet />
</main>
<p-toast />
<app-signup-modal
  [isOpen]="showSignupModal"
  (close)="closeSignupModal()"
></app-signup-modal>
